<template>
  <div class="book-detail-page">
    <headers v-if="!$store.state.app" :title="{name: '图书详情'}" :goBackHandler="goBack">
      <div slot="right-sum">
        <i
          :class="book_data.is_collected ? 'collect-img-hover':'collect-img'"
          @click.stop="collect(1)"
        ></i>
        <i class="share-img" @click.stop="collect(2)"></i>
      </div>
    </headers>
    <section class="bd-info">
      <img class="cover" :src="book_data.cover_img" alt />
      <div>
        <div>
          <p class="bdi-title">{{book_data.book}}</p>
          <div class="teacher">{{book_data.author}}</div>
        </div>
        <div class="bdi-price">
          <p class="now-price">
            <icon-price v-if="book_data.price" :priceType="2"></icon-price>
            <span v-if="book_data.price">{{book_data.price | toFixPrice}}</span>
            <span v-else>免费</span>
          </p>
          <p class="under-price" v-if="book_data.underlined_price">
            <icon-price :priceType="2"></icon-price>
            <span>{{book_data.underlined_price | toFixPrice}}</span>
          </p>
          <p class="stock">
            <font>库存</font>
            <span>{{book_data.stock - book_data.sales_num}}</span>
          </p>
        </div>
      </div>
    </section>
    <active
      v-if="book_data.price"
      :couponList="coupon.all"
      :detail="book_data"
      @setCoupon="setCoupon"
    ></active>
    <div class="cd-tro com-style">
      <p class="cd-title">图书详情</p>
      <div class="cd-details" v-html="book_data.details"></div>
    </div>
    <div class="com-style">
      <p class="cd-title">图书评论</p>
      <commentItem></commentItem>
    </div>
    <book-share ref="share"></book-share>
    <div>
      <van-button class="book-btn" @click="submit">立即购买</van-button>
    </div>
  </div>
</template>

<script>
import bookShare from '@/components/book/BookShare.vue'
import headers from '@/components/Header.vue'
import active from '@/components/book/Active.vue'
import commentItem from '@/components/CommentItem'
export default {
  name: 'BookDetail',
  components: {
    headers,
    active,
    commentItem,
    bookShare
  },
  data() {
    return {
      id: this.$route.query.id,
      book_data: {},
      coupon: [],
      showShare: false
    }
  },
  methods: {
    goBack() {
      if (this.$store.state.app) {
        this.$store.commit('BACK_NORMAL', 0)
      }
      this.$router.go(-1)
    },
    async collect(type) {
      if (type == 1) {
        //   收藏
        if (this.book_data.is_collected) {
          // 取消收藏
          await this.$http.put(
            `/api/app/collect/cancel/${this.book_data.is_collected}/4`
          )
          this.$toast({
            message: '取消成功',
            duration: 800
          })
        } else {
          await this.$http.post(`/api/app/collect`, {
            book_id: this.id,
            type: 4
          })
          this.$toast({
            message: '收藏成功',
            icon: 'success',
            duration: 800
          })
        }
        this.getBookDetail()
      } else {
        //   分享
        this.$refs.share.showModel()
      }
    },
    async getBookDetail() {
      let book_data = await this.$http.get(`/api/app/book/detail/${this.id}`)
      this.book_data = book_data
      this.coupon = book_data.coupon
    },
    setCoupon(index) {
      this.couponList[index].is_can_get = 0
    },
    share() {
      if (this.$pub.checkLogin(true, 'push')) {
        this.showShare = true
        this.$nextTick(() => {
          this.$refs.share.showModel()
        })
      }
    },
    submit() {
      if (this.$pub.checkLogin(true, 'push')) {
        if (this.book_data.stock - this.book_data.sales_num <= 0) {
          this.$toast({
            message: '你来晚了哦,库存已经没有了~',
            duration: 1000
          })
        } else {
          this.$router.push({
            name: 'Purchase',
            query: {
              id: this.id,
              type: 12
            }
          })
        }
      }
    }
  },
  created() {
    // app内打开的地址管理，不关闭webview
    if (this.$store.state.app) {
      this.$store.commit('BACK_NORMAL', 1)
    }
    this.getBookDetail()
  }
}
</script>

<style lang="scss" scoped>
.book-detail-page {
  @extend %default-bg;
  padding-bottom: 125px;
  .collect-img {
    display: inline-block;
    width: 60px;
    height: 86px;
    background: url('~@/assets/images/book/collect.png') no-repeat center center;
    background-size: 36px 36px;
  }
  .collect-img-hover {
    display: inline-block;
    width: 60px;
    height: 86px;
    background: url('~@/assets/images/book/icon-star.png') no-repeat center
      center;
    background-size: 36px 36px;
  }
  .share-img {
    display: inline-block;
    width: 60px;
    height: 86px;
    background: url('~@/assets/images/book/share.png') no-repeat center center;
    background-size: 35px 35px;
  }
  .bd-info {
    background: #fff;
    display: flex;
    padding: 54px 62px;
    .cover {
      width: 206px;
      height: 288px;
      box-shadow: 0px 6px 14px 0px rgba(0, 0, 0, 0.35);
      flex: none;
    }
    > div {
      margin-left: 28px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      .bdi-title {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 48px;
      }
      .teacher {
        margin-top: 20px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(140, 140, 140, 1);
        line-height: 40px;
      }
      .bdi-price {
        display: flex;
        justify-content: space-between;
        /deep/ .price-ico {
          width: 16px;
          margin: 0 4px;
        }
        .now-price {
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(238, 31, 31, 1);
        }
        .under-price {
          flex: 1;
          font-size: 24px;
          color: #979797;
          margin-top: 6px;
          text-decoration: line-through;
        }
        .stock {
          padding: 0 30px;
          height: 40px;
          background: rgba(242, 242, 242, 1);
          border-radius: 20px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 40px;
          text-align: center;
          font {
            color: rgba(140, 140, 140, 1);
          }
          span {
            color: #595959;
          }
        }
      }
    }
  }
  .com-style {
    margin-top: 30px;
    background: #fff;
    padding: 10px 20px;
  }
  .cd-title {
    font-size: 30px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(38, 38, 38, 1);
    padding-top: 20px;
  }
  .cd-tro {
    .cd-details {
      font-size: 28px;
      padding: 30px 10px;
      /deep/ p {
        width: 100%;
      }
      /deep/ img {
        width: 100% !important;
      }
      /deep/ video {
        width: 100%;
      }
    }
  }
  .book-btn {
    position: fixed;
    width: 690px;
    height: 74px;
    bottom: 14px;
    background: $theme_color;
    text-align: center;
    line-height: 47px;
    font-size: 28px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    border-radius: 37px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
